import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import { generateDataTestidAttribute } from '../../../services/testid-service';

import { LoadingIndicator } from '../../loading-indicator';
import style from './modal-body.module.css';

export const ModalBody = ({ className = '', children, render, showLoading = false, shouldIgnoreRootFocus = false }) => {
  if (typeof render === 'function') {
    return render();
  }
  return (
    <div
      {...generateDataTestidAttribute('modal-body')}
      className={classNames(style['modal-body'], className)}
      data-ignore-root-focus={shouldIgnoreRootFocus || undefined}
    >
      {children}
      {showLoading && <LoadingIndicator className={style['loading-wrapper']} />}
    </div>
  );
};

ModalBody.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  render: PropTypes.func,
  showLoading: PropTypes.bool,
  shouldIgnoreRootFocus: PropTypes.bool,
};
